const React = require("react");
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
} from "constants/RemoteDataTableContanst";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import SearchTable from "../RemoteTable/search-table";
const RemoteDataTable = props => {
  const {
    keyField,
    caption,
    data,
    columns,
    page,
    sizePerPage,
    totalSize,
    onTableChange,
    rowEvents,
    selectRow,
    listRowAction,
    listMultipleRowAction,
    onSearchAllHandle,
    optionShowColumnHandel,
    children,
    loading,
    onRowsSelect,
    expandRow,
    isShowSearchAll,
    isShowPagination,
    customClassTable,
    isShowSTT,
  } = props;

  useEffect(() => {
    // reset row select when data change
    setRowSelected([]);
  }, [data]);
  const tableRef = useRef(null);
  const { t, i18n } = useTranslation("common");
  const [rowSelected, setRowSelected] = useState([]);

  // Init custom column
  const initColumn = () => {
    // Col rowIndex
    const rowIndexColumn = {
      dataField: "rowIndex",
      text: t("index"),
      hidden: !isShowSTT,
      formatter: (cellContent, row, enumObject) => (
        <span>{(page - 1) * sizePerPage + enumObject + 1}</span>
      ),
    };
    // Default columns
    const initColumn = [...columns];
    // Nếu có col expand
    if (columns.findIndex(item => item.dataField === "dfExpand") !== -1) {
      initColumn.splice(1, 0, rowIndexColumn);
    } else {
      initColumn.splice(0, 0, rowIndexColumn);
    }
    if (listRowAction?.length > 0) {
      const columnAction = {
        dataField: "action",
        text: t("action"),
        isDummyField: true,
        headerStyle: {
          textAlign: "center",
        },
        formatter: (cellContent, row, enumObject) =>
          generateAction(row, enumObject),
      };
      initColumn.push(columnAction);
    }
    return initColumn;
  };

  const scrollBottomTable = () => {
    setTimeout(() => {
      let scroll = null;
      scroll = tableRef?.current?.scrollHeight;
      tableRef.current.scrollTop = scroll;
    });
  };

  /* If > maxAction thì thành button ... */
  const maxAction = 2;
  // Filter conditionVisible of action if have
  const generateAction = (row, rowIndex) => {
    let isCurrentMonth = true;
    if (row.ttchung_nlap) {
      const currentMonth = new Date().getMonth() + 1;
      const currentNlap = new Date(row.ttchung_nlap * 1000).getMonth() + 1;
      // Setup qua tháng sẽ là hóa đơn điều chỉnh, không làm thay thế cho trường hợp hóa đơn ở trên giao diện
      if (currentNlap < currentMonth) {
        isCurrentMonth = false;
      } else {
        isCurrentMonth = true;
      }
    }
    const listActionFinal = listRowAction.filter(item => {
      // Setup qua tháng sẽ là hóa đơn điều chỉnh, không làm thay thế cho trường hợp hóa đơn ở trên giao diện
      if (item.isCurrentMonthOnly && !isCurrentMonth) {
        return false;
      }
      let isShow = checkVisibleByConditionRowData(
        item.isShow,
        row,
        item?.conditionVisible
      );
      //   // WorkFlows action condition
      //   const workflowAction = row.workflowAction;
      //   if (item.actionCode) {
      //     isShow = false;
      //     if (workflowAction !== null && workflowAction.actions?.length) {
      //       isShow =
      //         workflowAction.actions.findIndex(
      //           action => action.code === item.actionCode
      //         ) !== -1
      //           ? true
      //           : false;
      //     }
      //   }
      return isShow;
    });
    const listActionOut = listActionFinal.slice(0, maxAction);
    const listActionMore = listActionFinal.slice(maxAction);
    return (
      <div
        className="d-flex gap-2 align-items-center justify-content-start col-action"
        style={{ lineHeight: "14px" }}
      >
        {listActionOut.map((action, index) => {
          // listDropdownFinal
          let listDropdownFinal = action.isDropdown
            ? action.listDropdown.filter((actionMore, indexMore) => {
                let isShow = checkVisibleByConditionRowData(
                  actionMore.isShow,
                  row,
                  actionMore?.conditionVisible
                );
                return isShow;
              })
            : [];
          return (
            <React.Fragment key={index}>
              {/* Button more actions */}

              {action.isDropdown ? (
                listDropdownFinal.length > 0 && (
                  <React.Fragment>
                    <UncontrolledDropdown
                      direction="left"
                      className="text-center"
                    >
                      <DropdownToggle
                        id={"action" + index + rowIndex}
                        href="#"
                        disabled={loading}
                        style={{ cursor: loading ? "not-allowed" : "pointer" }}
                        className="card-drop"
                        tag="i"
                        onClick={() => {
                          scrollBottomTable();
                        }}
                      >
                        {action.icon}
                        <UncontrolledTooltip
                          placement="top"
                          target={"action" + index + rowIndex}
                        >
                          {action.text}
                        </UncontrolledTooltip>
                      </DropdownToggle>
                      <DropdownMenu
                        className={`dropdown-menu-end ${
                          action?.classDropdown || "dropdown-menu-1"
                        }`}
                        style={{
                          zIndex: 5,
                          border: " 1px solid #808080d4",
                        }}
                      >
                        {listDropdownFinal.map((actionMore, indexMore) => {
                          return (
                            <DropdownItem
                              href="#"
                              key={indexMore}
                              className="d-flex gap-3 align-items-center"
                              onClick={() => {
                                actionMore.onClick &&
                                  actionMore.onClick(row, rowIndex);
                              }}
                            >
                              {actionMore.icon}
                              {actionMore.text}
                            </DropdownItem>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </React.Fragment>
                )
              ) : (
                <div
                  id={"action" + index + rowIndex}
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  onClick={() => {
                    if (loading) return;
                    action.onClick && action.onClick(row, rowIndex);
                  }}
                >
                  {action.icon}
                  <UncontrolledTooltip
                    placement="top"
                    target={"action" + index + rowIndex}
                  >
                    {action.text}
                  </UncontrolledTooltip>
                </div>
              )}
              {index === maxAction - 1 && listActionMore.length > 0 && (
                <UncontrolledDropdown direction="left" className="text-center">
                  <DropdownToggle
                    id={"actionMore" + index + rowIndex}
                    href="#"
                    disabled={loading}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    className="card-drop"
                    tag="i"
                  >
                    <i
                      className="mdi mdi-dots-vertical font-size-18"
                      onClick={() => {
                        scrollBottomTable();
                      }}
                    />
                  </DropdownToggle>
                  <UncontrolledTooltip
                    placement="top"
                    target={"actionMore" + index + rowIndex}
                  >
                    {t("moreAction")}
                  </UncontrolledTooltip>
                  <DropdownMenu
                    className="dropdown-menu-end"
                    style={{ zIndex: 5, border: " 1px solid #808080d4" }}
                  >
                    {listActionMore.map((actionMore, indexMore) => {
                      return (
                        <DropdownItem
                          href="#"
                          key={indexMore}
                          className="d-flex gap-3 align-items-center"
                          onClick={() => {
                            actionMore.onClick &&
                              actionMore.onClick(row, rowIndex);
                          }}
                        >
                          {actionMore.icon}
                          {actionMore.text}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  // }

  const customHeaderStyle = () => {
    // If table have column filter
    if (
      $(".react-bootstrap-table > table tr > th:has(>label)").length > 0 ||
      $(".react-bootstrap-table > table tr > th:has(>.date-filter)").length > 0
    ) {
      // $(".react-bootstrap-table > table tr > th:not(:has(>label))").css(
      //     "padding-bottom",
      //     "19px"
      //   );
      $(".react-bootstrap-table > table tr > th:not(:has(>label))").css(
        "padding-bottom",
        "56px"
      );
      if ($(".date-filter").css("display") === "flex") {
        $(".react-bootstrap-table > table tr > th:has(.date-filter)").css(
          "padding-bottom",
          ""
        );
      }
    } else {
      // If table dont have column filter
      $(".react-bootstrap-table > table tr > th").css("padding-bottom", "");
    }
    // Column check box
    $(".react-bootstrap-table > table tr > th:has(input)").css(
      "padding-bottom",
      ""
    );
    // $(
    //   ".react-bootstrap-table table > tbody > tr > td:last-child, .react-bootstrap-table table > thead > tr:last-child > th:last-child"
    // ).css({
    //   position: "sticky",
    //   right: "0",
    //   "z-index": 1,
    //   background: "white",
    //   "border-left": "1px solid red",
    // });
  };

  const FILTER_DATE_COMPARATOR = {
    "~": "~",
    "=": "eq",
    "!=": "neq",
    ">": "gt",
    ">=": "gte",
    "<": "lt",
    "<=": "lte",
  };

  // Format data
  const formatDataTable = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters }
  ) => {
    sortOrder = sortOrder === "desc" ? "-" : "";
    // Filter
    const columnFilter = {};
    for (const key in filters) {
      const filterType = filters[key].filterType;
      const filterVal = filters[key].filterVal;
      switch (filterType) {
        case "SELECT":
          columnFilter[`filter[${key}]`] = filterVal;
          break;
        case "TEXT":
          if (key === "id" || key === "root_id" || key === "child_id") {
            columnFilter[`filter[${key}]`] = filterVal.trim();
          } else {
            columnFilter[`filter[${key}][like]`] = filterVal.trim();
          }
          break;
        case CUSTOM_DATE_FILTER_TABLE_TYPE:
          if (filterVal.date && filterVal.date.length > 0) {
            let dateCustom = [];
            for (const filterDate of filterVal.date) {
              const offset = filterDate.getTimezoneOffset();
              const date = new Date(filterDate.getTime() - offset * 60 * 1000);
              dateCustom.push(date.toISOString().split("T")[0]);
            }
            const comparatorCustom =
              FILTER_DATE_COMPARATOR[filterVal.comparator];
            if (dateCustom && comparatorCustom) {
              if (dateCustom.length > 1) {
                columnFilter[`filter[${key}][gte]`] = dateCustom[0];
                columnFilter[`filter[${key}][lte]`] = dateCustom[1];
              } else {
                const date = dateCustom[0];
                columnFilter[`filter[${key}][${comparatorCustom}]`] = date;
              }
            }
          }
          break;
        case "DATE":
          const date = filterVal.date;
          const comparator = FILTER_DATE_COMPARATOR[filterVal.comparator];
          if (date && comparator) {
            columnFilter[`filter[${key}][${comparator}]`] = date
              .toISOString()
              .split("T")[0];
          }
          break;
        case CUSTOM_SELECT_FILTER_TABLE_TYPE:
          if (filterVal.data && filterVal.data.value) {
            columnFilter[`filter[${key}]`] = filterVal.data.value;
          }
          break;
        default:
          break;
      }
    }
    //
    onTableChange(type, {
      page,
      sizePerPage,
      sortField,
      sortOrder,
      columnFilter,
    });
  };

  const MODE_CHECKBOX = "checkbox";
  const MODE_RADIO = "radio";

  /* START custom row select (checkbox / radio ...)  */
  const handleOnSelect = (row, isSelect) => {
    let data = [];

    if (selectRowCustom.mode === MODE_CHECKBOX) {
      if (isSelect) {
        data = [...rowSelected, row[keyField]];
      } else {
        data = rowSelected.filter(x => x !== row[keyField]);
      }
    } else if (selectRowCustom.mode === MODE_RADIO) {
      data = [row[keyField]];
    }
    setRowSelected(data);
    onRowsSelect && onRowsSelect(data);
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r[keyField]);
    let data = [];
    if (isSelect) {
      data = ids;
    }
    setRowSelected(data);
    onRowsSelect && onRowsSelect(data);
  };

  const selectRowCustom = {
    clickToSelect: false,
    ...selectRow,
    selected: rowSelected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  /* END custom row select (checkbox / radio ...)  */

  /* START custom noData  */
  const defaultEmptyDataMessage = () => {
    return <div className="text-center">{t("table_empty")}</div>;
  };
  /* END custom noData  */

  const checkVisibleByConditionRowData = (
    isShowData,
    rowData,
    conditionVisibleData
  ) => {
    if (isShowData === false) {
      return false;
    }
    let isShow = isShowData !== undefined ? isShowData : true;
    // Normal action condition
    const conditionVisible = conditionVisibleData;
    if (conditionVisible) {
      for (const key of Object.keys(conditionVisible)) {
        const k = key.split(".");
        let lastValue = rowData;
        for (const item of k) {
          lastValue = lastValue?.[item] ? lastValue[item] : null;
        }
        if (conditionVisible[key].length === 0) {
          isShow = lastValue ? true : false;
        } else {
          if (
            lastValue &&
            conditionVisible[key].findIndex(c => c === lastValue) === -1
          ) {
            isShow = false;
          }
        }
        if (isShow === false) {
          break;
        }
      }
    }
    return isShow;
  };

  return (
    <PaginationProvider
      pagination={paginationFactory({
        page,
        sizePerPage,
        totalSize,
        custom: true,
        sizePerPageList: [
          {
            text: "10",
            value: 10,
          },
          {
            text: "25",
            value: 25,
          },
          {
            text: "35",
            value: 35,
          },
          {
            text: "50", // max from api
            value: 50,
          },
        ],
      })}
    >
      {({ paginationProps, paginationTableProps }) => (
        <ToolkitProvider
          keyField={keyField}
          columns={initColumn()}
          data={data}
          columnToggle
        >
          {toolkitProps => (
            <React.Fragment>
              {isShowSearchAll && (
                <SearchTable
                  loading={loading}
                  optionShowColumnHandel={optionShowColumnHandel}
                  onSearchAllHandle={onSearchAllHandle}
                  columnToggleProps={toolkitProps.columnToggleProps}
                  rowSelected={rowSelected}
                  listMultipleRowAction={listMultipleRowAction}
                >
                  {children}
                </SearchTable>
              )}

              <Row>
                <Col xl="12">
                  <div
                    className={`table-responsive ${customClassTable}`}
                    ref={tableRef}
                  >
                    <BootstrapTable
                      remote
                      caption={caption}
                      filter={filterFactory()}
                      wrapperClasses={
                        listRowAction?.length > 0 ? "table-col-action" : ""
                      }
                      responsive
                      selectRow={selectRow ? selectRowCustom : undefined}
                      expandRow={expandRow ? expandRow : undefined}
                      hover={true}
                      rowEvents={rowEvents}
                      loading={loading}
                      onTableChange={formatDataTable}
                      overlay={overlayFactory({
                        spinner: true,
                        styles: {
                          overlay: base => ({
                            ...base,
                            "z-index": 2,
                            background: "#e9ecef",
                          }),
                        },
                      })}
                      noDataIndication={defaultEmptyDataMessage}
                      bordered={true}
                      // striped={true}
                      classes={"table align-middle table-nowrap"}
                      {...toolkitProps.baseProps}
                      {...paginationTableProps}
                    />
                  </div>
                </Col>
              </Row>
              {isShowPagination && (
                <Row
                  className="align-items-md-center mt-30"
                  style={{ marginTop: "5px" }}
                >
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              )}
            </React.Fragment>
          )}
        </ToolkitProvider>
      )}
    </PaginationProvider>
  );
};

RemoteDataTable.propTypes = {
  isShowPagination: PropTypes.bool,
  loading: PropTypes.bool,
  keyField: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  rowEvents: PropTypes.object,
  columnToggleProps: PropTypes.any,
  children: PropTypes.any,
  onSearchAllHandle: PropTypes.func, // call back button tìm kiếm
  optionShowColumnHandel: PropTypes.func, // call back button ẩn hiện column
  listRowAction: PropTypes.array, // action từng dòng
  listMultipleRowAction: PropTypes.array, // action button tác vụ hàng loạt
  selectRow: PropTypes.object,
  onRowsSelect: PropTypes.func, // call back when select row (Checkbox / radio)
  expandRow: PropTypes.object,
  isShowSearchAll: PropTypes.bool,
  customClassTable: PropTypes.any,
  caption: PropTypes.any,
  isShowSTT: PropTypes.any,
};

RemoteDataTable.defaultProps = {
  isShowSTT: true,
  caption: undefined,
  isShowSearchAll: true,
  isShowPagination: true,
  customClassTable: "custom-remote-table",
};

export default RemoteDataTable;
